import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageDesignation() {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editID, setEditID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({ facing: "" });

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true, width:"10%" },
    { name: "Designation", selector: (row) => row.name, sortable: true, width:"80%" },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row._id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const fetchAllDesignations = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getDesignations();
      const arr = res?.data?.map((ele, ind) => ({
        sln: ind + 1,
        name: ele.name,
        id: ele._id,
      }));
      setDesignations(arr);
    } catch (error) {
      console.error("Error fetching designations:", error);
      toast.error("Failed to load designations!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllDesignations();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({ name: row.name });
    setEditID(row.id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: `Delete Designation?${id}`,
      text: "Are you sure you want to delete this designation?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteDesigation(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Designation has been deleted.", "success");
          fetchAllDesignations();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete designation.", "error");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { name: editData.name };
      if (isEdit) {
        const res = await HomeService.updateDesignation(editID, data);
        if (res?.status) {
          toast.success("Designation updated successfully!");
          setIsEdit(false);
          setEditData({ name: "" });
          fetchAllDesignations();
        }
      }
    } catch (error) {
      toast.error("Failed to save designation.");
      console.error("Error saving designation:", error);
    }
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit && (
            <section className="chartBox_area">
              <h2>Edit Designation</h2>
              <hr />
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Designation Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={editData.name}
                      onChange={(e) =>
                        setEditData({ ...editData, name: e.target.value })
                      }
                      placeholder="Enter Designation"
                      required
                    />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary mt-3">
                  Save Changes
                </button>
              </form>
            </section>
          )}

          <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Manage Designation
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <DataTable
                columns={columns}
                data={designations}
                pagination
                responsive
                highlightOnHover
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageDesignation;
